import { ReportOverviewIF } from "../reports/types"
import styles from "./Accounting.module.css"
export const AccountingOverview = (props: {
    overview?: ReportOverviewIF, isLoading?: boolean
}) => {
    const { overview, isLoading } = props

    return <div className={styles.sidebar}>
        <div className={styles.sidebar_content}>
            <div>
                <p>Attempted Bets</p>
                <p>{(!isLoading && overview?.attempted) || '-'}</p>
            </div>
            <div>
                <p>Unique Bets</p>
                <p>{(!isLoading && overview?.unique) || '-'}</p>
            </div>
            <div>
                <p>Placed Bets</p>
                <p>{(!isLoading && overview?.placed) || '-'}</p>
            </div>
            <div style={{ paddingTop: '0.5rem' }}>
                <p>Bets Won</p>
                <p>{(!isLoading && overview?.won) || '-'}</p>
            </div>
            <div>
                <p>Bets Lost</p>
                <p>{(!isLoading && overview?.lost) || '-'}</p>
            </div>
            <div style={{ paddingTop: '0.5rem' }}>
                <p>Total Risked</p>
                <p>{(!isLoading && `$${(overview?.amountRisked || 0).toFixed(2)}`) || '-'}</p>
            </div>
            <div>
                <p>Total Won</p>
                <p style={{ color: 'var(--success)' }}>{(!isLoading && `$${(
                    overview?.amountWon || 0
                ).toFixed(2)}`) || '-'}</p>
            </div>
            <div>
                <p>Total Lost</p>
                <p style={{ color: 'var(--danger)' }}>{(!isLoading && `$${(
                    overview?.amountLost || 0
                ).toFixed(2)}`) || '-'}</p>
            </div>
            <div style={{ paddingTop: '0.5rem' }}>
                <p>Net</p>
                <p
                    style={{
                        color:
                            !overview ||
                                overview?.amountWon === overview?.amountLost
                                ? 'var(--text1)'
                                : overview?.amountWon > overview?.amountLost
                                    ? 'var(--success)'
                                    : 'var(--danger)',
                    }}
                >
                    {(!isLoading && `$${(overview?.net || 0).toFixed(2)}`) || '-'}
                </p>
            </div>
            <div>
                <p>Net Liable</p>
                <p
                    style={{
                        color:
                            !overview ||
                                overview?.amountWon === overview?.amountLost
                                ? 'var(--text1)'
                                : overview?.amountWon > overview?.amountLost
                                    ? 'var(--success)'
                                    : 'var(--danger)',
                    }}
                >
                    {(!isLoading && `$${(overview?.netLiable || 0).toFixed(2)}`) || '-'}
                </p>
            </div>
            <div>
                <p>Net Bettor Liable</p>
                <p
                    style={{
                        color:
                            !overview ||
                                overview?.amountWon === overview?.amountLost
                                ? 'var(--text1)'
                                : overview?.amountWon > overview?.amountLost
                                    ? 'var(--success)'
                                    : 'var(--danger)',
                    }}
                >
                    {(!isLoading && `$${(overview?.netBettorLiable || 0).toFixed(2)}`) || '-'}
                </p>
            </div>
        </div>
    </div>
}